const CART = "checkout";
const SHIPPING = "shipping";
const PAYMENT = "payment";
const REVIEW = "review";

const getCurrentStep = (path) => {
  const currentList = checkOutSteps.filter((step) => step.key === path);
  return currentList.length ? currentList?.at(0) : checkOutSteps[1];
};

const checkOutSteps = [
  {
    key: SHIPPING,
    progress: 1,
    icon: "bi bi-truck",
    name: "frontend.checkout.shipping",
    state: "",
    next: "payment",
    previous: "/shopping-cart",
    link: "shipping",
  },
  {
    key: PAYMENT,
    progress: 2,
    icon: "bi bi-credit-card",
    name: "Payment & Billing",
    state: "",
    previous: "shipping",
    next: "review",
    link: "payment",
  },
  {
    key: REVIEW,
    progress: 3,
    icon: "bi bi-check-circle-fill",
    name: "Place order",
    state: "",
    previous: "payment",
    next: "",
  },
];

export { checkOutSteps, CART, SHIPPING, PAYMENT, REVIEW, getCurrentStep };
